import React from 'react';

import { getDisplayName } from '@cp-shared-19/frontend-ui';

import { withLoadingHandler, withLoadingHandlerProps } from './withLoadingHandler';
import { withNoConnectionHandler, withNoConnectionHandlerProps } from './withNoConnectionHandler';

export const withLoadingAndNoConnectionHandler = <TProps extends Record<string, unknown>>(
    WrappedComponent: React.ComponentType<TProps>,
): React.FC<TProps & withNoConnectionHandlerProps & withLoadingHandlerProps> => {
    const ComponentWithHocs = withLoadingHandler(withNoConnectionHandler(WrappedComponent));
    ComponentWithHocs.displayName = `withLoadingAndNoConnectionHandler(${getDisplayName(WrappedComponent)})`;
    return ComponentWithHocs;
};
